import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';

import PhoneSetup from './../components/PhoneSetup';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    carriers: state.carriers,
    business: state.business,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneSetup);
